<!-- 生活 -->
<template>
  <div class="w100">
    <van-nav-bar class="gradient" :title="$t('common.life')" :fixed="true">
      <span slot="right" @click="_linkFun('/order')">
        {{ $t("life.myOrder") }}
      </span>
    </van-nav-bar>
    <div class="search-wrap fixed-search">
      <div class="location text-blue" @click="locationFlag = true">
        <van-icon name="location-o" />
        <span>{{ location.city ? location.city : $t("life.locating") }}</span>
        <van-icon name="arrow-down" />
      </div>
      <van-search
        class="white"
        @click="searchFlag = true"
        v-model="searchVal"
        shape="round"
        readonly
        :placeholder="$t('life.enterMerchantCommodity')"
      />
    </div>
    <!-- <vue-search
      class="fixed-search"
      :locationFlag.sync="locationFlag"
      :searchFlag.sync="searchFlag"
    /> -->
    <div class="content-wrapper">
      <scroll ref="scroll">
        <div class="column-wrapper">
          <div class="column">
            <div class="title">{{ $t("life.recommendMerchant") }}</div>
            <div class="recommended">
              <div
                class="item"
                :class="{ long: index < 2 }"
                @click="_linkFun('/store?shopId=' + item.shop_id)"
                v-for="(item, index) in recommended"
                :key="index"
              >
                <div class="image"><img :src="httpUrl + item.image" /></div>
                <div class="info">
                  <h3 class="text-hidden">{{ item.shop_name }}</h3>
                  <p class="text-orange text-hidden">{{ item.ad_text }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="column store">
            <div class="title">{{ $t("life.nearbyMerchant") }}</div>
            <store-list
              v-for="(item, index) in storeList"
              :data="item"
              :key="index"
            />
          </div>
        </div>
      </scroll>
    </div>

    <popup v-if="couponFlag" :couponFlag.sync="couponFlag" :list="couponList" />
    <!-- 定位 -->
    <transition name="slide">
      <location v-if="locationFlag" :locationFlag.sync="locationFlag"  @nearbyStore="nearbyStore"/>
    </transition>
    <!-- 商家商品搜索 -->
    <transition name="slide">
      <store-search v-if="searchFlag" :searchFlag.sync="searchFlag" />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Popup from "@/components/life/popup";
import Location from "./location";
import StoreSearch from "./search";
import StoreList from "@/components/life/storeList/storeList";
export default {
  name: "life",
  meta: {
    tabNav: true, // 显示菜单
    power: false, // 权限
    service: false // 客服
  },
  components: {
    Popup,
    Location,
    StoreSearch,
    StoreList
  },
  data() {
    return {
      lat: "22.544986",
      lng: "114.064794",
      locationFlag: false, // 位置Flag
      couponFlag: false, // 优惠券弹窗
      couponList: [],
      recommended: [],
      storeList: [],
      searchFlag: false, //搜索FLag
      searchVal: ""
    };
  },
  created() {
    // this.getLocation();
    this.sendCoupon();
    this.recommendationStore();
    this.nearbyStore();
    // 获取定位
    this.$store.dispatch("SET_LOCATION");
  },
  mounted() {
    // this.couponFlag = true;
  },
  computed: {
    ...mapGetters(["location"])
  },
  methods: {
    getLocation() {
      let data = {
        output: "json",
        latlng: this.lat + "," + this.lng,
        sensor: true,
        key: "AIzaSyCP8wu3wUtUEeHtar4qE7ftbWGRdcYKn80"
      };
      this.$get("https://maps.google.com/maps/api/geocode", data).then(res => {
        console.log("getLocation", res);
      });
    },
    sendCoupon() {
      // 获取推荐商家信息
      let vm = this;
      vm.$post(
        "/app/store/sendCoupon",
        {},
        {
          loading: true
        }
      ).then(res => {
        console.log("sendCoupon", res);
        vm.couponList = res.list;
        // if (vm.couponList.length) {
        if (
          vm.couponList.length &&
          window.location.href.indexOf("localhost") == -1
        ) {
          setTimeout(() => {
            vm.couponFlag = true;
          }, 2000);
        }
      });
    },
    recommendationStore() {
      // 获取推荐商家信息
      let vm = this;
      let params = {};
      params.latitude = vm.lat;
      params.longitude = vm.lng;
      vm.$post("/app/store/recommendationStore", params, {
        loading: true
      }).then(res => {
        console.log("recommendationStore", res);
        vm.recommended = res.list;
      });
    },
    nearbyStore() {
      // 获取附近商家信息
      let vm = this;
      let params = {};
      params.latitude = vm.location.latitude;
      params.longitude = vm.location.longitude;
      vm.$post("/app/store/nearbyStore", params, {
        loading: true
      }).then(res => {
        console.log("nearbyStore", res);
        vm.storeList = res.list;
      });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
@images: "~@/assets/images/";
.search-wrap {
  top: 44px;
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 10px;
  height: 48px;
  background: #fff;
  .location {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 90px;
    font-size: 14px;
    overflow: hidden;
    span {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .van-icon {
      margin-right: 2px;
      font-size: 16px;
    }
  }
  .van-search {
    flex: 1;
    margin-left: 5px;
    padding: 0;
    .van-search__content {
      background: #fff;
      border: 1.1px solid #dcdcdc;
    }
    .van-cell {
      padding: 3px 8px 3px 0;
    }
    /deep/.van-icon-search {
      color: #bcbcbc;
    }
  }
}
.content-wrapper {
  background: #eee;
  top: 92px;
  .column-wrapper {
    padding: 1.1px 0;
    .column {
      margin: 10px;
      box-shadow: none;
    }
  }
}

.recommended {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding: 0 10px;
  .item {
    margin-left: 12px;
    margin-bottom: 10px;
    width: calc(33.33% - 8px);
    height: 120px;
    background: #f4f4f4;
    border-radius: 4px;
    overflow: hidden;
    &.long {
      width: calc(50% - 6px);
    }
    &:nth-of-type(1),
    &:nth-of-type(3) {
      margin-left: 0;
    }
    .image {
      height: 80px;
      overflow: hidden;
      img {
        width: 100%;
      }
    }
    .info {
      padding: 4px 5px;
      h3 {
        font-size: 14px;
        font-weight: 400;
        line-height: 16px;
      }
      p {
        padding-top: 4px;
        line-height: 12px;
      }
    }
  }
}

.store {
  background: none;
  border-radius: 0;
  .title {
    padding: 0px;
  }
}
</style>
